import { useState, useCallback } from "react"
import { Box, VStack, Heading, Input, Button, Text, Card, Stack } from "@chakra-ui/react"
import { useNavigate } from "react-router-dom"
import { authClient } from "../auth/auth"

export const PasswordChange = () => {
  const navigate = useNavigate()
  const [currentPassword, setCurrentPassword] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [error, setError] = useState("")
  const [success, setSuccess] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleSubmit = useCallback(
    async (e: React.FormEvent) => {
      e.preventDefault()
      setError("")
      setSuccess(false)

      // Validation
      if (!currentPassword || !newPassword || !confirmPassword) {
        setError("All fields are required")
        return
      }

      if (newPassword.length < 8) {
        setError("New password must be at least 8 characters")
        return
      }

      if (newPassword !== confirmPassword) {
        setError("New passwords do not match")
        return
      }

      setLoading(true)

      try {
        await authClient.changePassword({
          currentPassword,
          newPassword,
        })

        setSuccess(true)
        setCurrentPassword("")
        setNewPassword("")
        setConfirmPassword("")

        // Redirect to home after 2 seconds
        setTimeout(() => {
          navigate("/")
        }, 2000)
      } catch (err: any) {
        setError(err.message || "Failed to change password")
      } finally {
        setLoading(false)
      }
    },
    [currentPassword, newPassword, confirmPassword, navigate]
  )

  return (
    <Box width="100%" height="100%">
      <form onSubmit={handleSubmit}>
        <VStack gap={4} align="stretch">
          <Stack gap={1}>
            <Text fontSize="sm" fontWeight="medium">
              Current Password *
            </Text>
            <Input
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              placeholder="Enter current password"
            />
          </Stack>

          <Stack gap={1}>
            <Text fontSize="sm" fontWeight="medium">
              New Password *
            </Text>
            <Input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter new password"
            />
            <Text fontSize="xs" color="gray.500">
              Must be at least 8 characters
            </Text>
          </Stack>

          <Stack gap={1}>
            <Text fontSize="sm" fontWeight="medium">
              Confirm New Password *
            </Text>
            <Input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm new password"
            />
          </Stack>

          {error && (
            <Text color="red.500" fontSize="sm">
              {error}
            </Text>
          )}

          {success && (
            <Text color="green.500" fontSize="sm">
              Password changed successfully! Redirecting...
            </Text>
          )}

          <Button type="submit" variant={"hydrologiq_primary" as any} loading={loading} width="full">
            Change Password
          </Button>
        </VStack>
      </form>
    </Box>
  )
}
